<template>
	<div class="p-0 min-h-screen bg-gray-100">
		<div class="bg-white py-4 px-6 border-b border-gray-200">
			<div class="mb-2">
				<router-link :to="`/template/${templateId}/state/${stateId}`" class="text-gray-500 no-underline text-sm inline-flex items-center hover:text-gray-700">
					<i class="fa fa-arrow-left mr-2"></i>
					Back to Template State
				</router-link>
			</div>
			<div class="flex justify-between items-center">
				<h1 class="text-2xl font-semibold text-gray-900 m-0">Edit Template Position ({{ positionType }})</h1>
				<button
					class="bg-violet-600 text-white border-none rounded-md py-2 px-4 text-sm font-medium cursor-pointer hover:bg-violet-700 disabled:opacity-50 disabled:cursor-not-allowed"
					@click="savePosition"
					:disabled="isSaving"
				>
					{{ isSaving ? 'Saving...' : 'Save Changes' }}
				</button>
			</div>
		</div>

		<div class="p-6">
			<div v-if="isLoading" class="py-12 px-6 text-center text-gray-500">Loading position...</div>

			<div v-else class="bg-white rounded-lg shadow-sm">
				<div class="flex justify-between items-center py-4 px-6 border-b border-gray-200">
					<h2 class="text-lg font-semibold text-gray-900 m-0">Position Properties</h2>
				</div>
				<div class="p-6">
					<div v-if="positionType === 'photo'" class="grid grid-cols-[repeat(auto-fill,minmax(280px,1fr))] gap-4">
						<div>
							<label class="block text-sm font-medium text-gray-700 mb-1">X</label>
							<input v-model.number="position.x" type="number" class="w-full py-2 px-3 border border-gray-300 rounded-md text-sm box-border focus:border-violet-600 focus:outline-none">
						</div>
						<div>
							<label class="block text-sm font-medium text-gray-700 mb-1">Y</label>
							<input v-model.number="position.y" type="number" class="w-full py-2 px-3 border border-gray-300 rounded-md text-sm box-border focus:border-violet-600 focus:outline-none">
						</div>
						<div>
							<label class="block text-sm font-medium text-gray-700 mb-1">Width</label>
							<input v-model.number="position.width" type="number" class="w-full py-2 px-3 border border-gray-300 rounded-md text-sm box-border focus:border-violet-600 focus:outline-none">
						</div>
						<div>
							<label class="block text-sm font-medium text-gray-700 mb-1">Height</label>
							<input v-model.number="position.height" type="number" class="w-full py-2 px-3 border border-gray-300 rounded-md text-sm box-border focus:border-violet-600 focus:outline-none">
						</div>
						<div>
							<label class="block text-sm font-medium text-gray-700 mb-1">Rotation</label>
							<input v-model.number="position.rotation" type="number" class="w-full py-2 px-3 border border-gray-300 rounded-md text-sm box-border focus:border-violet-600 focus:outline-none">
						</div>
						<div>
							<label class="block text-sm font-medium text-gray-700 mb-1">Border Radius</label>
							<input v-model.number="position.borderRadius" type="number" class="w-full py-2 px-3 border border-gray-300 rounded-md text-sm box-border focus:border-violet-600 focus:outline-none">
						</div>
						<div>
							<label class="block text-sm font-medium text-gray-700 mb-1">Mask</label>
							<select v-model="position.mask" class="w-full py-2 px-3 border border-gray-300 rounded-md text-sm box-border focus:border-violet-600 focus:outline-none">
								<option value="">None</option>
								<option v-for="m in masks" :key="m" :value="m">{{ m }}</option>
							</select>
						</div>
						<div>
							<label class="block text-sm font-medium text-gray-700 mb-1">Border Image</label>
							<select v-model.number="position.borderimageid" class="w-full py-2 px-3 border border-gray-300 rounded-md text-sm box-border focus:border-violet-600 focus:outline-none">
								<option :value="null">None</option>
								<option v-for="bi in borderImages" :key="bi.id" :value="bi.id">{{ bi.name || bi.id }}</option>
							</select>
						</div>
					</div>

					<div v-else class="grid grid-cols-[repeat(auto-fill,minmax(280px,1fr))] gap-4">
						<div>
							<label class="block text-sm font-medium text-gray-700 mb-1">X</label>
							<input v-model.number="position.x" type="number" class="w-full py-2 px-3 border border-gray-300 rounded-md text-sm box-border focus:border-violet-600 focus:outline-none">
						</div>
						<div>
							<label class="block text-sm font-medium text-gray-700 mb-1">Y</label>
							<input v-model.number="position.y" type="number" class="w-full py-2 px-3 border border-gray-300 rounded-md text-sm box-border focus:border-violet-600 focus:outline-none">
						</div>
						<div>
							<label class="block text-sm font-medium text-gray-700 mb-1">Width</label>
							<input v-model.number="position.width" type="number" class="w-full py-2 px-3 border border-gray-300 rounded-md text-sm box-border focus:border-violet-600 focus:outline-none">
						</div>
						<div>
							<label class="block text-sm font-medium text-gray-700 mb-1">Height</label>
							<input v-model.number="position.height" type="number" class="w-full py-2 px-3 border border-gray-300 rounded-md text-sm box-border focus:border-violet-600 focus:outline-none">
						</div>
						<div>
							<label class="block text-sm font-medium text-gray-700 mb-1">Rotation</label>
							<input v-model.number="position.rotation" type="number" class="w-full py-2 px-3 border border-gray-300 rounded-md text-sm box-border focus:border-violet-600 focus:outline-none">
						</div>
						<div>
							<label class="block text-sm font-medium text-gray-700 mb-1">Font</label>
							<select v-model.number="position.fontid" class="w-full py-2 px-3 border border-gray-300 rounded-md text-sm box-border focus:border-violet-600 focus:outline-none">
								<option :value="null">None</option>
								<option v-for="f in fonts" :key="f.id" :value="f.id">{{ f.name || f.id }}</option>
							</select>
						</div>
						<div>
							<label class="block text-sm font-medium text-gray-700 mb-1">Font Size</label>
							<input v-model.number="position.fontSize" type="number" class="w-full py-2 px-3 border border-gray-300 rounded-md text-sm box-border focus:border-violet-600 focus:outline-none">
						</div>
						<div>
							<label class="block text-sm font-medium text-gray-700 mb-1">Text Color</label>
							<input v-model="position.textColor" type="text" class="w-full py-2 px-3 border border-gray-300 rounded-md text-sm box-border focus:border-violet-600 focus:outline-none" placeholder="#000000">
						</div>
						<div>
							<label class="block text-sm font-medium text-gray-700 mb-1">Text Alignment</label>
							<select v-model="position.textAlignment" class="w-full py-2 px-3 border border-gray-300 rounded-md text-sm box-border focus:border-violet-600 focus:outline-none">
								<option value="left">Left</option>
								<option value="center">Center</option>
								<option value="right">Right</option>
							</select>
						</div>
						<div>
							<label class="block text-sm font-medium text-gray-700 mb-1">Default Text</label>
							<input v-model="position.defaultText" type="text" class="w-full py-2 px-3 border border-gray-300 rounded-md text-sm box-border focus:border-violet-600 focus:outline-none">
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, computed } from 'vue';
import { useRoute } from 'vue-router';
import { httpClient } from 'utils/http';
import Swal from 'sweetalert2';

export default defineComponent({
	name: 'EditTemplatePositionPage',
	setup() {
		const route = useRoute();
		const templateId = route.params.templateid as string;
		const stateId = route.params.id as string;
		const positionId = route.params.positionid as string;
		const positionType = computed(() => (route.query.type as string) || 'photo');

		const position = ref<any>({});
		const borderImages = ref<any[]>([]);
		const fonts = ref<any[]>([]);
		const isLoading = ref(false);
		const isSaving = ref(false);

		const masks = ['circle', 'heart', 'diamond', 'brush', 'cloud', 'star', 'flower', 'stamp', 'octagon', 'clover'];

		const loadPosition = async () => {
			isLoading.value = true;
			try {
				const url = positionType.value === 'photo' ? 'templatepositionphoto' : 'templatepositiontext';
				const { data } = await httpClient.get(`/api/${url}/${positionId}`);
				position.value = data;
			} catch (error: any) {
				Swal.fire({
					title: 'Error',
					text: error.message || 'Failed to load position',
					icon: 'error',
				});
			} finally {
				isLoading.value = false;
			}
		};

		const loadReferenceData = async () => {
			try {
				const [biResp, fontResp] = await Promise.all([
					httpClient.get<any[]>('/api/borderimage?limit=0'),
					httpClient.get<any[]>('/api/font?limit=0'),
				]);
				borderImages.value = biResp.data;
				fonts.value = fontResp.data;
			} catch (error: any) {
				console.error('Failed to load reference data:', error);
			}
		};

		const savePosition = async () => {
			isSaving.value = true;
			try {
				const url = positionType.value === 'photo' ? 'templatepositionphoto' : 'templatepositiontext';
				await httpClient.put(`/api/${url}/${positionId}`, position.value);
				Swal.fire({
					title: 'Saved',
					text: 'Position has been saved',
					icon: 'success',
					timer: 1500,
				});
			} catch (error: any) {
				Swal.fire({
					title: 'Error',
					text: error.message || 'Failed to save position',
					icon: 'error',
				});
			} finally {
				isSaving.value = false;
			}
		};

		onMounted(async () => {
			await Promise.all([loadPosition(), loadReferenceData()]);
		});

		return {
			templateId,
			stateId,
			positionType,
			position,
			borderImages,
			fonts,
			masks,
			isLoading,
			isSaving,
			savePosition,
		};
	},
});
</script>
